import http from "@/helper/http";
import {MenuPO} from "@/model/system";
import {useMutation} from "@tanstack/react-query";
import {BaseVO} from "@/model/global";
import {ReactNode} from "react";
import {Breakpoint} from "@mui/system/createBreakpoints/createBreakpoints";

export enum MenuEnum {
    GetRoutes = "/menu/getRoutes",
    GetButtons = "/menu/getButtons",
}

/**
 * 全部字典VO
 */
export interface AuthRouteVO extends MenuPO {
    children?: AuthRouteVO[];
}

export interface AuthButtonVO extends MenuPO {
    children?: MenuPO[];
    disabled?: boolean;
    body?: ReactNode;
    maxWidth?: Breakpoint;
}

/**
 * 授权菜单
 */
export const useQueryAuthRoutes = () => useMutation({
        mutationFn: () => http.get<BaseVO<AuthRouteVO[]>>({url: MenuEnum.GetRoutes})
    }
)

/**
 * 获取按钮
 */
export const useQueryAuthButtons = () => useMutation({
    mutationFn: () => http.get<BaseVO<AuthButtonVO[]>>({url: MenuEnum.GetButtons})
})
